import React from "react";
import { RequestComment } from "@/types/requestComment";
import { DateCell } from "@/components/pages/settlement/components/table-cells/DateCell";
import { Avatar } from "@radix-ui/react-avatar";
import { AvatarFallback } from "@/components/ui/avatar";
import { CircleUserIcon } from "lucide-react";
import { Badge } from "@/components/ui/badge";

type Props = { comment: RequestComment };

export const CommentItem: React.FC<Props> = ({ comment }) => {
  const date = comment.createdAt ? new Date(comment.createdAt) : null;
  return (
    <div className="grid grid-cols-3 gap-x-6 items-center">
      <DateCell
        date={date}
        className={"flex flex-row justify-self-start min-w-0"}
      />
      <div
        className={"flex flex-row gap-1 justify-center items-center min-w-0"}
      >
        <Avatar className="shrink-0">
          <AvatarFallback className="bg-transparent">
            <CircleUserIcon />
          </AvatarFallback>
        </Avatar>
        <span className="truncate">
          {`${comment.author?.firstName} ${comment.author?.lastName}`}{" "}
          {comment.author?.staff?.userTeams?.length ? (
            <Badge>
              {comment.author.staff.userTeams
                .map((ut) => ut.team.name)
                .join(", ")}
            </Badge>
          ) : null}
        </span>
      </div>
      <span className={"justify-self-end break-all min-w-0"}>
        {comment.content}
      </span>
    </div>
  );
};

export default CommentItem;
